import { FC, useState, useEffect, useMemo } from "react";
import { Input } from "modules/common";
import { ReactComponent as DeleteIcon } from "assets/icons/delete.svg";
import { IRangeInputProps } from "modules/common/components/Alarms/Form/components/CountiesStations/types/IRangeInputProps";
import { ErrorMap, validateWithZod } from "modules/common/utils/validateWithZod";
import { createRangeInputSchema } from "modules/common/components/Alarms/Form/components/Measurements/schemas/RangeInputSchema";
import z from "zod";
import { IconButton } from "modules/common/components/Alarms/Form/components/IconButton";

const RangeInput: FC<IRangeInputProps> = ({
    keyValue,
    title,
    min,
    max,
    onMinChange,
    onMaxChange,
    removeRangeInput,
}) => {
    const rangeInputSchema = useMemo(() => createRangeInputSchema(keyValue), [keyValue]);
    const [errors, setErrors] = useState<ErrorMap<z.infer<typeof rangeInputSchema>>>({});

    useEffect(() => {
        const validation = validateWithZod(rangeInputSchema, { min, max });
        if (validation.success) {
            setErrors({});
        } else {
            setErrors(validation.errors);
        }
    }, [min, max, rangeInputSchema]);

    function handleInputChange(
        e: React.ChangeEvent<HTMLInputElement>,
        callback: (keyValue: any, value?: number) => void
    ) {
        const stringValue = e.target.value;
        if (stringValue === "" || stringValue === "-") {
            callback(keyValue, undefined);
        } else {
            const value = parseFloat(stringValue);
            callback(keyValue, isNaN(value) ? undefined : value);
        }
    }

    return (
        <div className="alarms-range-inputs">
            <label className="alarms-form-label">{title}</label>
            <div className="alarms-range-treshold-icon-and-inputs">
                <div className="alarms-form-range-treshold-container">
                    <div>
                        <Input
                            id={`min-${keyValue}`}
                            name={`min-${keyValue}`}
                            type="number"
                            size="medium"
                            value={min ?? ""}
                            placeholder="Donja granica"
                            label="Donja granica"
                            isValid={!errors.min}
                            errorMessage={errors.min}
                            onChange={e => handleInputChange(e, onMinChange)}
                        />
                    </div>
                    <div>
                        <Input
                            id={`max-${keyValue}`}
                            name={`max-${keyValue}`}
                            type="number"
                            size="medium"
                            value={max ?? ""}
                            placeholder="Gornja granica"
                            label="Gornja granica"
                            isValid={!errors.max}
                            errorMessage={errors.max}
                            onChange={e => handleInputChange(e, onMaxChange)}
                        />
                    </div>
                    <IconButton onClick={() => removeRangeInput(keyValue)} type="button">
                        <DeleteIcon />
                    </IconButton>
                </div>
            </div>
        </div>
    );
};

export default RangeInput;
